module.exports = __webpack_public_path__ + "img/alloy.9d7857ba.png";